import { useState } from 'react'
import { COST_TYPES, COST_TYPE_META } from './useRecipeState'

const CostTypeChip = ({ type, onClick, clickable }) => {
  const meta = COST_TYPE_META[type] || COST_TYPE_META.labor
  const cls = `chip ${meta.chipClass}${clickable ? ' chip-clickable' : ''}`
  return (
    <span className={cls} onClick={onClick}>
      {meta.label}
      {clickable && <span style={{ fontSize: 8, marginLeft: 2, opacity: 0.5 }}>{'\u25BE'}</span>}
    </span>
  )
}

export const CostTypeSelector = ({ value, onChange }) => {
  const [open, setOpen] = useState(false)
  return (
    <div style={{ position: 'relative' }}>
      <CostTypeChip type={value} clickable onClick={() => setOpen(!open)} />
      {open && (
        <>
          <div className="popover-backdrop" onClick={() => setOpen(false)} />
          <div className="popover" style={{ top: '100%', marginTop: 4, left: 0 }}>
            {COST_TYPES.map(ct => {
              const meta = COST_TYPE_META[ct]
              return (
                <div key={ct}
                  className={`popover-item${ct === value ? ' selected' : ''}`}
                  style={{ color: `var(--${ct})` }}
                  onClick={() => { onChange(ct); setOpen(false) }}>
                  <span className="dot" style={{ width: 5, height: 5, borderRadius: '50%', background: `var(--${ct})` }} />
                  {meta.label}
                  {ct === value && <span style={{ marginLeft: 'auto', fontSize: 10 }}>{'\u2713'}</span>}
                </div>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}

export default CostTypeChip
